import { API } from "@/services"

export const USER_ENDPOINTS = {
  findMe(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `user/me`,
      method: 'GET',
      params,
    })
  },
}